import HeaderBar from "../../../Components/UI/headerbar";
import TransactionsTab from "../components/TransactionsTab";

const PaymentRecordsPage = () => {

  return (
    <div className="container-fluid">
      <HeaderBar
        title="إدارة الماليات"
        content="إدارة المدفوعات والعمولات والمدفوعات."
      />
      <TransactionsTab />
    </div>
  );
};

export default PaymentRecordsPage;
